import React, { useEffect, useRef } from 'react';
import JsBarcode from 'jsbarcode';

interface BarcodeProps {
  value: string;
}

export const Barcode = (props: BarcodeProps) => {
  const barcodeRef = useRef(null);

  useEffect(() => {
    if (barcodeRef.current) {
      JsBarcode(barcodeRef.current, props.value, {
        format: 'CODE128', // Matches 'C128' used in PHP
        lineColor: '#000',
        width: 2,
        height: 50,
        displayValue: true, // Show the text below the barcode
      });
    }
  }, [props.value]);

  return <svg ref={barcodeRef}></svg>;
};
